<template>
  <div>
      <div class="row mt-2 mb-2 px-5">
        <div class="col-sm-12 col-md-12 col-xl-7 mt-3 mb-3">
          <div id="div-modal-anular" class="w-100">
            <div id="div-anular" class="card w-100">
                <div class="card w-100">
                    <div class="card-header bg-main text-white text-center d-flex align-items-center justify-content-center">
                        <h6 class="card-title mb-0">RESERVAS</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                        <div class="col-md-12 py-2">
                            <div class="card-body">
                            <FullCalendar :options="calendarOptions" />
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-xl-5 mt-3">
          <div id="div-anular" class="card w-100">
            <div class="card w-100">
                <div class="card-header bg-main text-white d-flex justify-content-between align-items-center">
                    <h6 class="card-title mb-0">FECHA</h6>
                    <span>{{ booking.reservation_date }}</span>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-xl-12 mb-3" >
                            <label for="startTime" class="form-label" style="text-align: left; display: block;">Paciente</label>
                            <v-select
                                class="text-dark flex-grow-1 mt-1"
                                label="name"
                                :options="patientOptions"
                                placeholder="Seleccione Paciente"
                                @search="mtdGetPatient"
                                v-model="booking.patient_id"
                                :reduce="(name) => name.id"
                                required
                                :clearable="false"
                                @input="mtdGetActo(booking.patient_id)"
                            >
                                <template slot="no-options">
                                No hay Pacientes para la busqueda
                                </template>
                            </v-select>
                        </div>

                        <div class="col-12 col-xl-6 mb-3" >
                            <label for="startTime" class="form-label" style="text-align: left; display: block;">Acto Medico</label>
                            <v-select
                                class="text-dark flex-grow-1 mt-1"
                                label="name"
                                :options="actoOptions"
                                placeholder="Seleccione Acto Med."
                                v-model="booking.acto_id"
                                :reduce="(name) => name.id"
                                required
                                :clearable="false"
                                :disabled="!booking.patient_id"
                            >
                                <template slot="no-options">
                                No hay Acto Medico para la busqueda
                                </template>
                            </v-select>
                        </div>

                        <div class="col-12 col-xl-6 mb-3" >
                            <label for="startTime" class="form-label" style="text-align: left; display: block;">Servicios</label>
                            <v-select
                                class="text-dark flex-grow-1 mt-1"
                                label="name"
                                :options="serviciosOptions"
                                placeholder="Seleccione Servicios"
                                @search="mtdGetServicios"
                                v-model="booking.servicios_id"
                                :reduce="(name) => name.id"
                                required
                                :clearable="false"
                            >
                                <template slot="no-options">
                                No hay Servicios para la busqueda
                                </template>
                            </v-select>
                        </div>

                        <div class="col-12 col-xl-6 mb-3">
                            <label for="startTime" class="form-label" style="text-align: left; display: block;">Hora de inicio</label>
                            <input 
                                type="time" 
                                class="form-control form-control-sm" 
                                id="startTime" 
                                v-model="booking.start_time" 
                            />
                        </div>

                        <div class="col-12 col-xl-6 mb-3">
                            <label for="timeType" class="form-label" style="text-align: left; display: block;">TIPO (H, M)</label>
                            <select 
                                class="form-control form-control-sm" 
                                id="timeType"
                                v-model="booking.time_type"
                                :disabled="!booking.start_time"
                            >
                                <option value="" disabled>Seleccione Tipo</option>
                                <option :value="1">Horas</option>
                                <option :value="0">Minutos</option>
                            </select>
                        </div>

                        <div class="col-12 col-xl-6 mb-3">
                            <label for="quantity" class="form-label" style="text-align: left; display: block;">Cantidad</label>
                            <input 
                                type="number" 
                                class="form-control form-control-sm" 
                                id="quantity" 
                                v-model.number="booking.time" 
                                :disabled="booking.time_type === null || !booking.start_time" 
                                min="1"
                            />
                        </div>

                        <div class="col-12 col-xl-6 mb-3">
                            <label for="endTime" class="form-label" style="text-align: left; display: block;">Hora Final</label>
                            <input 
                                type="time" 
                                class="form-control form-control-sm" 
                                id="endTime" 
                                v-model="booking.end_time" 
                                disabled
                            />
                        </div>

                        <div class="col-12 col-xl-12 mt-2 d-flex justify-content-end">
                            <button type="button" class="btn btn-sm"  :class="isSaveDisabled ? 'btn-secondary' : 'btn-info text-white'"
                            :disabled="isSaveDisabled" @click="registerReserva()">
                                <i class="fas fa-calendar-check"></i> Guardar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    <cModalDetalleReserva
        :title="modal.title"
        :boo_modal="modal.modal_form"
        :item="modal.item"
        @closeModal="closeModal"
    />
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import cModalDetalleReserva from "./Modals/cModalDetalleReserva.vue";
import moment from "moment";

export default {
  name: "c-rehabilitacion-reservas",
  components: {
    FullCalendar,
    SweetAlert,
    cModalDetalleReserva 
  },
  data() {
    return {
      swal: null,
      patientOptions: [],
      serviciosOptions: [],
      actoOptions: [],
      ofCall: [],
      calendarOptions: {
        locale: "es",
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        events: [],
        initialView: "dayGridMonth",
        buttonText: {
          today: "Hoy",
          month: "Meses",
          week: "Semanas",
          day: "Días",
        },
        headerToolbar: {
          left: "title",
          center: "",
          left: "prev,next today",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        weekends: true,
        selectable: true,
        editable: false,
        validRange: {
          start: Date.now(),
        },
        dateClick: this.dateClick,
        eventClick: this.handleEventClick,

        dayMaxEventRows: true,
        //eventLimit: true,
        views: {
          timeGridWeek: {
            dayMaxEventRows: 5,
          },
        },
        eventMouseEnter: function(info) {
          info.el.style.cursor = 'pointer'; 
        },
        eventMouseLeave: function(info) {
          info.el.style.cursor = ''; 
        }
      },
      booking: {
        id: "",
        reservation_date: "",
        start_time: "",
        end_time: "",
        time_type: "", 
        time: 1,
        patient_id: "",
        acto_id: "",
        servicios_id: "",
        note: ""
      },
      events: [],
      modal: {
        title: "",
        item: [],
        modal_form: false,
      },
    };
  },
  created() {
    this.mtdGetHour();
  },
  watch: {
    events: {
      handler(newEvents) {
        this.calendarOptions.events = newEvents;
      },
      deep: true,
    },

    'booking.start_time': function(newVal) {
        this.triggerCalculateEndTime();
    },
    'booking.time': function(newVal) {
        this.triggerCalculateEndTime();
    },
    'booking.time_type': function(newVal) {
        this.triggerCalculateEndTime();
    },
  },
  computed: {
    isSaveDisabled() {
        return (
            !this.booking.reservation_date || 
            !this.booking.start_time ||       
            !this.booking.end_time ||        
            this.booking.time_type === "" ||  
            !this.booking.patient_id ||       
            !this.booking.acto_id  ||
            !this.booking.servicios_id              
        );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdGetPatient: function (search, loading) {
        if (search.length > 2) {
            this.patientOptions = [];
            this.booking.patient_id =  "",
            loading(true);
            this.get({
                url: this.$store.getters.get__url + "/Rehabilitation/mtdGetPatient",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.patientOptions = response.data;
                loading(false);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
    },

    mtdGetServicios: function (search, loading) {
        if (search.length > 2) {
            this.serviciosOptions = [];
            this.booking.servicios_id =  "",
            loading(true);
            this.get({
                url: this.$store.getters.get__url + "/Rehabilitation/mtdGetServicios",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.serviciosOptions = response.data;
                loading(false);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
    },

    mtdGetActo: function (patientId) {
        this.get({
            url: this.$store.getters.get__url + "/Rehabilitation/mtdGetActo/" + patientId,
            token: this.$store.getters.get__token,
        })
        .then((response) => {
            this.actoOptions = response.data;
        })
        .catch((errors) => {
            this.$refs.SweetAlert.showError(errors);
        });
    },

    triggerCalculateEndTime() {
        if (this.booking.start_time && this.booking.time > 0 && this.booking.time_type !== "") {
        this.calculateEndTime();
        }
    },

    calculateEndTime() {
      if (!this.booking.start_time || !this.booking.time || this.booking.time <= 0) return;

      const [hours, minutes] = this.booking.start_time.split(':');
      let startDate = new Date();
      startDate.setHours(parseInt(hours));
      startDate.setMinutes(parseInt(minutes));

      if (this.booking.time_type === 1) {
        startDate.setHours(startDate.getHours() + this.booking.time);
      } else if (this.booking.time_type === 0) {
        startDate.setMinutes(startDate.getMinutes() + this.booking.time);
      }
      const formattedEndTime = startDate.toTimeString().slice(0, 5);
      this.booking.end_time = formattedEndTime;
    },

    dateClick: function (info) {
      const date2 = new Date(info.date);
      const date = info.dateStr;
      const olddate = new Date();
      var ano = olddate.getFullYear();
      var mes = ("0" + (olddate.getMonth() + 1)).slice(-2);
      var dia = ("0" + olddate.getDate()).slice(-2);
      var fechaFormateada = ano + "-" + mes + "-" + dia;
      if (date < fechaFormateada) {
        this.$refs.SweetAlert.showWarning("Elija una Fecha Válida");
      } else {
        const auxiliar = this.fixDate(date2, "date-en");
        this.booking.reservation_date = moment(auxiliar).format("DD/MM/YYYY");
        this.ultimaFechaSeleccionada = date;
      }
    },

    fixDate(date, type) {
      let dateFixed = "";
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hours = "";
      switch (type) {
        case "date-es":
          if (date.getDate() < 10) day = "0" + day;
          dateFixed = `${day}/${month}/${year}`;
          break;
        case "date-en":
          if (date.getDate() < 10) day = "0" + day;
          dateFixed = `${year}-${month}-${day}`;
          break;
        case "time":
          date.getHours() < 10
            ? (hours += "0" + date.getHours())
            : (hours = date.getHours());
          dateFixed = `${hours}:${date.getMinutes().toString().padStart(2, "0")}`;
          break;

        default:
          break;
      }
      return dateFixed;
    },

    registerReserva: function() {
        Swal.fire({
          icon: "warning",
          title: "¿Estás seguro de Registrar esta Reserva?",
          input: "textarea",
          inputAttributes: {
            autocapitalize: "off",
            placeholder: "Comentario",
          },
          width: "400px",
          confirmButtonText: "Permitir",
          confirmButtonColor: "#3085d6",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          cancelButtonText: "Cerrar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.booking.note = result.value;
            this.registerReser();
          }
        });
    },

    registerReser: function() {
        this.post({
            url: this.$store.getters.get__url + "/Rehabilitation/registerReserva",
            token: this.$store.getters.get__token,
            params: this.booking,
        })
        .then((response) => {
            if(response.data.state == 0){
                this.$refs.SweetAlert.showSuccess("Reserva Registrada Correctamente");
                this.events.splice(0, this.events.length);
                this.mtdGetHour();
                this.clearData();
            }else if(response.data.state == 1){
                this.$refs.SweetAlert.showWarning(
                `Hay cruce de horarios para la fecha ${this.booking.reservation_date}`
                );
            }else{
                this.$refs.SweetAlert.showError("Error");
            }
        })
        .catch((errors) => {
            this.$refs.SweetAlert.showError(errors);
        });
    },

    mtdGetHour: function () {
      this.get({
        url: this.$store.getters.get__url + "/Rehabilitation/countReserva",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.ofCall = response.data;
          this.bringDate();
        })
        .catch((error) => {
            this.$refs.SweetAlert.showError(error);
        });
    },

    bringDate: function () {
        this.ofCall.forEach((item) => {
            let backgroundColor;
            const title = item.patient_document || "Sin Documento"; 

            switch (item.state) {
            case 1:
                backgroundColor = "#17a2b8";
                break;
            default:
                backgroundColor = "gray";
                break;
            }

            let localTimeStar = moment(item.start_time, "HH:mm:ss");
            let tranStartDate = localTimeStar.format("[T]HH:mm:ss");

            let localTimeEnd = moment(item.end_time, "HH:mm:ss");
            let tranEndDate = localTimeEnd.format("[T]HH:mm:ss");
            const startDate = item.date.includes("T")
            ? item.date
            : item.date + tranStartDate;
            const endDate = item.date.includes("T")
            ? item.date
            : item.date + tranEndDate;
            
            const newEvent = {
                title: title, 
                start: startDate,
                end: endDate,
                backgroundColor: backgroundColor,
                borderColor: backgroundColor,
                textColor: "white",
                extendedProps: {
                    state: item.state,
                    date: item.date,
                    id: item.id,
                },
            };

            this.events.push(newEvent);
        });
    },

    //Modales
    handleEventClick: function (info) {
        this.closeModal();
      const state = info.event.extendedProps.state;
      const date = info.event.extendedProps.date;
      const id = info.event.extendedProps.id;
      const formattedDate = moment(date).format("DD/MM/YYYY");

      let stateText;

      switch (state) {
        case 1:
          stateText = "Reservado";
          break;
        default:
          stateText = "Desconocido";
          break;
      }
        this.get({
            url: this.$store.getters.get__url + "/Rehabilitation/detailReserva/" + id,
            token: this.$store.getters.get__token,
        })
        .then((response) => {
          this.modal.title = `Detalle de Reservas: ${formattedDate}`;
          this.modal.item.push(response.data);
          this.modal.modal_form = true;
        })
        .catch((error) => {
            this.$refs.SweetAlert.showError(error);
        });
    },

    closeModal: function () {
      this.modal = {
        title: "",
        modal_form: false,
        item: [],
      };
    },

    clearData: function(){
        this.patientOptions =  [],
        this.serviciosOptions = [],
        this.actoOptions = [],
        this.booking = {
            id: "",
            reservation_date: "",
            start_time: "",
            end_time: "",
            time_type: "", 
            time: 1,
            patient_id: "",
            acto_id: "",
            servicios_id: "",
            note: ""
        }
    }
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>
<style>
.fc-daygrid-day-number {
  color: black !important;
  text-decoration: none !important;
}
.fc-col-header-cell-cushion {
  color: black !important;
  text-decoration: none !important;
}
</style>

